<template lang="html">
    <div class="invitacion-webinar container">
        <div class="logo">
            <img width="143px" class="h-100 m-100" src="/static/img/logo.png" alt="Logo" />
        </div>
        <div class="header" style="color: white !important;">
            <h1> REQUERIMIENTOS EX POST INMEDIATO FORMACIÓN BONIFICADA</h1>
            <h3> JORNADA TÉCNICA </h3>
            <h2> Jueves 19 de Septiembre de 2024 </h2>
            <h2> de 10:00h a 11:00h </h2>
            <div>
                <a class="btn btn-white" href="https://forms.gle/noMwryEejCz59vfXA">
                    INSCRIBIRME
                </a>
            </div>
        </div>
        <div class="body">
            <p>
                El <b> Servicio Público de Empleo Estatal, </b> en cumplimiento de la normativa vigente, y con el fin de
                completar las labores de seguimiento y control de la ejecución de los cursos notificados en 2024, <b>
                    está
                    solicitando a entidades orgizadoras y/o empresas, documentación concreta para uno o varios grupos
                    formativos </b>
            </p>
            <p>
                Por ello, y <b> con el fin poner en común la documentación requerida, y la forma de presentación de la
                    misma, </b> hemos organizado este webinar
            </p>
            <p>
                En dicha sesión, aprovecharemos también la reciente incorporación en iformalia de <b> Marisa Cosmen </b>
                como <b> nueva Directora de Consultoría </b> para resolver cualquier duda que pueda haber al respecto.
            </p>
            <h4>
                Conoce cómo abordar este requermiento de manera sencilla y ágil
            </h4>
            <p>
                de la mano de 
                <a href="https://www.linkedin.com/in/emilio-segovia-99004323/"><b>Emilio Segovia</b></a> <i>(BDM en iformlia)</i>, 
                <a href="https://www.linkedin.com/in/aracelipelaez/"><b>Araceli Peláez</b></a> <i> (Directora de Gestión de Procesos y Clientes)</i> y 
                <a href="https://www.linkedin.com/in/marisa-cosmen-alonso-b7772342/"><b>Marisa Cosmen</b></a> <i>(Directora de Consultoría)</i>
            </p>
        </div>
        <div class="bloque">
            <p><b>Los temas que se tratarán son:</b></p>
            <ul>
                <li>Normativa aplicable</li>
                <li>Tipos de requermientos de información</li>
                <li>Actuaciones in situ vs Expost inmediato</li>
                <li>Aspectos que debemos recordar</li>
                <li>Contratos de Encomienda, Aula Virtual, RLT.</li>
                <li>Ruegos y preguntas</li>
            </ul>
        </div>
        <div>
            <a class="btn btn-blue" href="https://forms.gle/noMwryEejCz59vfXA">
                INSCRIBIRME
            </a>
            
        </div>
    </div>
</template>

<script lang="js">
export default {
    name: 'invitacion-webinar',
    props: [],
    mounted() {

    },
    data() {
        return {

        }
    },
    methods: {

    },
    computed: {

    }
}
</script>

<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Poppins:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&display=swap');
.invitacion-webinar {
    *{
        font-family: "Poppins", sans-serif !important;
    }
    &.container{
        padding-top: 20px;
        max-width: 1000px;
        padding-bottom: 50px;
        margin:auto;
    }

    .header {
        background: url(/static/img/newsletter/invitacion-webinar.png) center / cover no-repeat;
        padding-top: 80px;
        padding-bottom: 60px;
        margin-top: 20px;
        margin-bottom: 46px;
        
        color: white !important;

        h1{
            margin-bottom: 25px;
            font-size: 36px;
            font-weight: 700;
            color: white !important;
        }
        h3{
            margin-bottom: 10px;
            font-size: 16px;
            font-weight: 400;
            color: white !important;
        }
        h2{
            font-size: 24px; 
            color: white !important;
        }

        div{
            margin-top: 65px;
        }

        h1,h2 {
            text-shadow: 0px 8px 6px rgba(0,0,0,0.2);
        }
    }
    
    .body{
        color: #41576D;
        p{
            text-align: left;
            font-size: 14px;
            line-height: 24px;
            margin-bottom: 22px;
        }
        a:hover{
            text-decoration: underline;
        }
        h4{
            font-size: 24px;
            padding-left: 132px;
            padding-right: 132px;
            margin-top: 45px;
            margin-bottom: 45px;
            @media screen and (max-width: 900px){
                padding-left: 0px;
                padding-right: 0px;
            }
        }
    }

    .bloque{
        width: 512px;
        padding: 15px 40px;

        margin: auto;
        margin-bottom: 50px;

        background-color: #41576d38;
        border-radius: 5%;

        @media screen and (max-width: 900px){
            width: 95%;
            padding: 15px 15px;
        }

        p,li{
            text-align: left;
            color: #41576D;
            font-size: 14px;
        }
        p{
            margin-bottom: 15px;
        }
        ul{
            margin-bottom: 15px;
        }
        li{
            list-style: inside;
            padding-left: 30px;
            &::marker{
                font-size: 16px
            }
            @media screen and (max-width: 900px){
                padding-left: 0px;
            }
        }
    }

    .btn{
        font-size: 14px;
        border-radius: 45px;
        padding: 10px 60px;
        font-family: "Poppins", sans-serif !important;
        font-weight: 700;
    }

    .btn-white{
        background-color: #ffffff;
        color: #41576D;
    }
    .btn-white:hover{
        background-color: #41576D;
        color: #ffffff;
    }
    
    .btn-blue{
        background-color: #41576D;
        color: #ffffff;
    }
    .btn-blue:hover{
        background-color: #41576d38;
        color: #41576D;
    }
}
</style>


// WEBPACK FOOTER //
// src/components/views/invitacion-webinar.vue